import React, { useState, useEffect } from "react"
import { Autocomplete, Box, Button, FormControl, Stack, TextField, Typography } from "@mui/material"
import { ApiDownloadBulkRegionUpdate, ApiGetClientEntityByClientGroupId, ApiUploadBulkRegionUpdateExcel } from "../../../apiService/Core/Apicall.tsx";
import { toast } from "react-toastify";

export default function BulkRegionUpdate() {

    const [regions, setRegions] = useState<any[]>([])
    const [selectedRegion, setSelectedRegion] = useState<any>(null);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);

    const handleGetAldiRegions = async () => {
        try {
            const res: any = await ApiGetClientEntityByClientGroupId("?ClientGroupName=ALDI");
            const fullBusinessData = res?.data || [];
            const allRegions = fullBusinessData.flatMap((item: any) => item.regions || []);
            const regionOptions = allRegions.map((region: any) => ({
                label: region.regionName,
                value: region.regionId,
            }));
            setRegions(regionOptions);
            if (regionOptions.length > 0) {
                setSelectedRegion(regionOptions[0]);
            }
        } catch (error) {
            console.error("Error fetching ALDI regions:", error);
        }
    };
    useEffect(() => {
        handleGetAldiRegions()
    }, [])

    const handleDownloadExce = async() => {
        try {
            const data = `?regionId=${selectedRegion?.value}`
            const response = await ApiDownloadBulkRegionUpdate(data);
            const blob = new Blob([response], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `BulkRegionUpdate.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Error Downloading Excel.",error);
            toast.error("Error downloading excel data.")
        }
    }

    const handleUploadExcel = async () => {
        if (!selectedFile) {
            toast.error("Please select a file before uploading");
            return;
        }
        try {
            const formData = new FormData();
            formData.append("file", selectedFile);

            await ApiUploadBulkRegionUpdateExcel(formData);
            toast.success("Excel uploaded successfully!");
            setSelectedFile(null);
        } catch (error: any) {
            console.error("Upload failed:", error);
            toast.error(error?.response?.data?.message || "Failed to upload excel");
        }
    };


    return (
        <div>
            <Box sx={{ p: 4 }} style={{ background: "white" }}>
                <Stack spacing={3}>
                    <Box className="d-flex align-items-center justify-content-center flex-column" gap={6} sx={{ width: "100%" }}>
                        <h1 className="common-manage-h1" style={{ textAlign: "center" }}>
                            Bulk Region Update
                        </h1>
                        <Box className="d-flex align-items-center justify-content-center flex-column" gap={2}>
                            <FormControl>
                                <Autocomplete
                                    sx={{ minWidth: '250px' }}
                                    options={regions}
                                    value={selectedRegion}
                                    onChange={(event, newValue: any) => {
                                        setSelectedRegion(newValue);
                                    }}
                                    getOptionLabel={(option) => option.label || ''}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Select Region" />
                                    )}
                                />
                            </FormControl>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className="table-row-background px-5 py-2"
                                onClick={()=>handleDownloadExce()}
                            >
                                Export Existing Data
                            </Button>
                        </Box>
                    </Box>
                </Stack>
                <Box className="mt-4"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                    }}
                >
                    <label
                        htmlFor="updateExcel"
                        style={{
                            marginRight: "10px",
                            minWidth: "150px",
                            textAlign: "right",
                        }}
                    >
                        Upload Excel:
                    </label>
                    <input
                        type="file"
                        accept=".xlsx,.xls"
                        style={{ width: "calc(100% - 220px)" }}
                        onChange={(e) => setSelectedFile(e.target.files?.[0] || null)}
                    />
                    <Button variant="contained" color='primary' className='table-row-background add-update-button ml-2' onClick={handleUploadExcel}>
                        Update
                    </Button>
                </Box>
            </Box>
        </div>
    )
}